import { GET_USER_RECIPE_BOX } from 'graphql/recipebox';
import { GET_USER_DATA_SUMMARY } from 'graphql/userDataSummary';

export function updateRecipeInCache(userRecipeId) {
  return function update(cache, { data: { updateRecipeInBox } }) {
    try {
      const rb = cache.readQuery({
        query: GET_USER_RECIPE_BOX
      });
      cache.writeQuery({
        query: GET_USER_RECIPE_BOX,
        data: {
          recipeBox: {
            ...rb.recipeBox,
            recipes: [
              ...rb.recipeBox.recipes.filter(
                r => r.userRecipeId.toString() !== userRecipeId.toString()
              ),
              updateRecipeInBox.userRecipe
            ]
          }
        }
      });
    } catch (err) {
      // nothing to do here, sadly.
    }
  };
}

export function removeRecipeFromCache(userRecipeId) {
  return function update(
    cache,
    {
      data: {
        removeRecipeFromBox: { status }
      }
    }
  ) {
    if (status !== 200) {
      // eslint-disable-next-line no-console
      console.log(`Error deleting recipe from the box ${userRecipeId}`);
      return;
    }
    try {
      const rb = cache.readQuery({
        query: GET_USER_RECIPE_BOX
      });
      cache.writeQuery({
        query: GET_USER_RECIPE_BOX,
        data: {
          recipeBox: {
            ...rb.recipeBox,
            // Remove the deleted recipe
            recipes: rb.recipeBox.recipes.filter(
              r => r.userRecipeId !== userRecipeId
            )
          }
        }
      });
    } catch (err) {
      // nothing to do here, sadly.
    }
  };
}

export function updateRatingInCache(cache, { data: { rate } }) {
  try {
    const uds = cache.readQuery({
      query: GET_USER_DATA_SUMMARY
    });

    cache.writeQuery({
      query: GET_USER_DATA_SUMMARY,
      data: {
        getUserDataSummary: {
          ...uds.getUserDataSummary,
          ratedResources: [
            ...uds.getUserDataSummary.ratedResources.filter(
              r => r.ratedId !== rate.rating.ratedId
            ),
            rate.rating
          ]
        }
      }
    });
  } catch (err) {
    // nothing to do here, sadly.
  }
}

export default {
  updateRecipeInCache,
  removeRecipeFromCache,
  updateRatingInCache
};
